// https://apiv.sooqtest.com/v2.1/car-report/carfax/79670
import DynamicObject from "../../models/dynamic-object";
import { AxiosResponse} from "axios";
import Api from "../api";

export default (id:string, type : string,config?: DynamicObject): Promise<AxiosResponse> => {
    const path = 'car-report';
    const apiUrl : string = `${path}/${type}/${id}`;
    return Api.getInstance().request.get(apiUrl, path)
}